import { ChevronRight } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import Badge from "../../Badge";
import { IBreadcrumbProps } from "../types";
import * as S from "./styled";

const Breadcrumbs: React.FC<IBreadcrumbProps> = ({ breadcrumbs }) => {
    return (
        <S.Breadcrumbs>
            {breadcrumbs &&
                breadcrumbs.map((b, index) => {
                    const { title, icon, isBeta, ...restProps } = b;

                    return (
                        <React.Fragment key={title}>
                            {index > 0 && (
                                <S.BreadcrumbChevron>
                                    <ChevronRight size={18} />
                                </S.BreadcrumbChevron>
                            )}
                            <S.Breadcrumb as={restProps.to ? Link : "span"} {...restProps}>
                                {icon}
                                {title && <span>{title}</span>}
                                {isBeta && <Badge text="Beta" variant="secondary" />}
                            </S.Breadcrumb>
                        </React.Fragment>
                    );
                })}
        </S.Breadcrumbs>
    );
};

export default Breadcrumbs;
